import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'convert-to-html',
  version: '1.0.0',
  properties: [
    {
      key: 'inputText',
      label: 'Input Text',
      type: 'text',
      required: true,
      placeholder: '={{ $node["AI Agent"].output.output }}',
      description: 'Markdown text to convert to HTML. Supports variable interpolation.',
      typeOptions: {
        rows: 5,
      },
    },
    {
      key: 'includeWrapper',
      label: 'Include Email Wrapper',
      type: 'boolean',
      default: true,
      description: 'Wrap the HTML in a complete email template with header and footer',
    },
    {
      key: 'wrapperTitle',
      label: 'Title',
      type: 'string',
      default: 'Report',
      placeholder: 'Report Title',
      description: 'Title shown in the email header',
      displayOptions: {
        show: {
          includeWrapper: [true],
        },
      },
    },
    {
      key: 'includeHeader',
      label: 'Include Header',
      type: 'boolean',
      default: true,
      description: 'Include the gradient header with title',
      displayOptions: {
        show: {
          includeWrapper: [true],
        },
      },
    },
    {
      key: 'includeFooter',
      label: 'Include Footer',
      type: 'boolean',
      default: true,
      description: 'Include the footer with timestamp',
      displayOptions: {
        show: {
          includeWrapper: [true],
        },
      },
    },
    {
      key: 'headerGradientStart',
      label: 'Header Gradient Start',
      type: 'string',
      default: '#326F6B',
      placeholder: '#326F6B',
      description: 'Starting color for header gradient (hex code)',
      displayOptions: {
        show: {
          includeWrapper: [true],
          includeHeader: [true],
        },
      },
    },
    {
      key: 'headerGradientEnd',
      label: 'Header Gradient End',
      type: 'string',
      default: '#54B9B3',
      placeholder: '#54B9B3',
      description: 'Ending color for header gradient (hex code)',
      displayOptions: {
        show: {
          includeWrapper: [true],
          includeHeader: [true],
        },
      },
    },
    {
      key: 'customCss',
      label: 'Custom CSS',
      type: 'text',
      default: '',
      placeholder: '.custom-class { color: red; }',
      description: 'Additional CSS to include in the <style> tag',
      typeOptions: {
        rows: 3,
      },
      displayOptions: {
        show: {
          includeWrapper: [true],
        },
      },
    },
  ],
};

export default schema;
